/*
 * Channels that can be linked and published to right now.
 *
 * TikTok is held back: its publishing path has never run end to end (it asks
 * TikTok to pull from a URL it never sends, then uploads the whole file in one
 * request, which TikTok refuses past 64 MB). Until that is rebuilt it is not
 * offered as something to link or post to. An account someone linked earlier
 * stays visible in settings so it can still be unlinked.
 */
export const PUBLISHING_UNAVAILABLE = new Set(['TikTok']);

export const isPublishingAvailable = (channelType) => !PUBLISHING_UNAVAILABLE.has(channelType);
